import React, { useEffect, useState } from 'react';
import { isNumeric, isMonthAndYearEmpty, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { showLoading } from 'react-global-loading';

export default function RuralConsumerRetailPriceData({
  payload,
  blockCode,
  districtCode,
  monthName,
  yearName,
  urbanAndRuralCommonItemPrice,
  userInfoObject,
  resetMothAndYearField,
  config,
  url, 
  type,
  isReadOnlyMode = false }) {

  const [itemData, setItemData] = useState({});
  let subGroupsSerialNumber = 0;
  let ItemSerialNumber = 0;
  let districtAndDivision = false;
  let isDisable = false;
  let commonDisabledItemCode = "";
  if (type === 'urban') {
    commonDisabledItemCode = ['147', '172', '193', '194', '196', '197']
  } else {
    commonDisabledItemCode = ['135', '143', '144', '147', '148', '156', '159', '161', '162', '172', '173', '190',
      '192', '193', '194', '195', '196', '197', '200', '201', '203']
  }
  let headQuarterRemark=['Price is Too Low',
	'Price is too High',
	'Price does not match with unit' ,
	'Price does not match with variety',
    'Other.'
  ]
  let otherRemark=[
    'Production is low',
    'Production is high',
    'Less supply',
    'Not Available.',
    'On sale.',
    'Seasonal effect',
    'Discounted Item',
    'Other.'

  ]



  const navigate = useNavigate();
  const {
    isSaveBtnDisable,
    isSubmitBtnDisable,
    isAcceptBtnDisable,
    isRejectBtnDisable
  } = getButtonDisabledStates(payload, userInfoObject);
  
  // If in read-only mode, disable all action buttons
  let onlyDistrictSelected = districtCode && !blockCode;
  if(url==="UrbanConsumerRetailPriceInputFormDataSaveToDB"){ //new condition 16 Feb
     onlyDistrictSelected = false ;
  
  }
  
  // After HQ Accept/Reject finalize, keep Accept & Reject disabled even if only district is selected
  const hqStatusFlag = String(payload?.statusFlagSet ?? payload?.statusFlag ?? '');
  const isHqFinalized =
    userInfoObject.userLevel === 'HEAD QUARTER' &&
    (hqStatusFlag === '8' || hqStatusFlag === '6');

  const finalIsSaveBtnDisable = onlyDistrictSelected ? true : (isSaveBtnDisable || isReadOnlyMode);
  const finalIsSubmitBtnDisable = isHqFinalized
    ? true
    : (onlyDistrictSelected ? false : (isSubmitBtnDisable || isReadOnlyMode));
  const finalIsAcceptBtnDisable = isHqFinalized
    ? true
    : (onlyDistrictSelected ? false : (isAcceptBtnDisable || isReadOnlyMode));
  const finalIsRejectBtnDisable = isHqFinalized
    ? true
    : (onlyDistrictSelected ? false : (isRejectBtnDisable || isReadOnlyMode));





  const renderHeader = (i) => (
    <thead key={`thead-${i}`}>
      <tr>
        <th>Sl.No</th>
        <th>Code</th>
        <th>Item Categories</th>
        <th>Variety</th>
        <th>Unit</th>
        <th>Current Price</th>
        <th>Remarks</th>
        <th>Reject<br />Status</th>
      </tr>
    </thead>
  );

  const majorGroupRow = (i, mjgroup) => (
    <tr key={`tbody-majorGroup-${i}`}>
      <td>
        <div className="sub_child">
          <span className="star">*  </span> <input type="text" id={`superSlno${i + 1}`} className="form-control" disabled
            maxLength="3" value={i + 1} />
        </div>
      </td>
      <td><input type="text" id={`majorGroupCode${i + 1}`} className="form-control" disabled maxLength="3" value={mjgroup.majorGroupCode} /></td>
      <td><input type="text" id={`majorGroupName${i + 1}`} className="form-control" disabled maxLength="50" value={mjgroup.majorGroupName} /></td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </tr>

  )

  const subGroupRow = (subGroupsSerialNumber, i, j, sbgroup) => (
    <tr key={`row-${j}-${subGroupsSerialNumber}`}>
      <td>
        <div className="sub_child">
          <span className="star">**</span> <input type="text" id={`subSlno${subGroupsSerialNumber}`} className="form-control" disabled
            maxLength="3" value={subGroupsSerialNumber} />
        </div>
      </td>
      <td><input type="text" id={`subGroupCode${subGroupsSerialNumber}`} className="form-control" disabled maxLength="3" value={sbgroup.subGroupCode} /></td>
      <td><input type="text" id={`subGroupName${subGroupsSerialNumber}`} className="form-control" disabled maxLength="50"
        value={sbgroup.subGroupName} /></td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </tr>
  )


  const handleOnChange = (itemCode, field, newValue) => {

    // In HQ read-only mode, still allow edits when only district is selected (block is blank)
    if (isReadOnlyMode && !onlyDistrictSelected) {
      return;
    }

    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
    let isRequiredRemark = false;

    if (field === 'currentPrice' && !isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

    if (field === 'remark' && itemData[itemCode].isRequiredRemark === false
      && newValue === '' && itemData[itemCode].remark === '') {
      isRequiredRemark = true
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [itemCode]: {
          ...prevItemData[itemCode],
          [field]: newValue,
          'isRequiredRemark': isRequiredRemark
        }
      };

      return updatedItemData;
    });


  };


  useEffect(() => {
    const initialData = {};
    urbanAndRuralCommonItemPrice.forEach(group => {
      group.subGroups.forEach(subGroup => {
        subGroup.itemCodes.forEach(item => {
          const remarkValue = item.remark ?? item.Remark ?? item.remarks ?? '';
          // const priceValue = !blockCode && type === 'urban'
          //   ? (item.average  ?? item.currentPrice ?? item.current_price ?? '')
          //   : (item.currentPrice ?? item.current_price ?? '');

         
        const priceValue =
        type === "urban"
          ? item.currentPrice
          : type === "rural"
            ? (blockCode ? item.currentPrice : item.average)
            : '';

          initialData[item.itemCode] = {
            currentPrice: priceValue,
            remark: remarkValue,
            statusFlag: item.statusFlag ?? item.status_flag ?? '',
            style: {
              borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
              borderStyle: 'solid',
              borderWidth: '1px 1px 1px 3px'
            },
            isRequiredRemark: false,
            isRejectStatus: item.statusFlag === '6'

          };
        });
      });
    });
    setItemData(initialData);
  }, [urbanAndRuralCommonItemPrice, blockCode]);



  const validateItemVariationPrice = (itemCode, field, newValue, average, variation) => {

    // In HQ read-only mode, still allow validation when only district is selected (block is blank)
    if (isReadOnlyMode && !onlyDistrictSelected) {
      return;
    }

    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }

    let dynamicStylesForTextBox = {}
    let isRequiredRemark = false

    if (newValue !== 0) {
      let dif = average * variation / 100;
      if (variation === 0 || dif === 0) {
        return;
      }
      if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
        toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
        dynamicStylesForTextBox = {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        newValue = dynamicStylesForTextBox
        if (itemData[itemCode].remark === 'NQ' || itemData[itemCode].remark === '') {
          isRequiredRemark = true
        }


      } else {

        dynamicStylesForTextBox = {
          borderColor: '#dcdfe1',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        isRequiredRemark = false
        newValue = dynamicStylesForTextBox


      }
    }


    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: newValue,
        'isRequiredRemark': isRequiredRemark
      }
    }));

  }



  const handleCheckboxChange = (itemCode, field, newValue) => {
    // When only district selected, allow checkbox (same as Submit/Accept/Reject); else block in read-only mode
    if (isReadOnlyMode && !onlyDistrictSelected) {
      return;
    }
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
    let isRequiredRemark = (itemData[itemCode]?.remark ? false : true); //required validation for Remarks
    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: !prevItemData[itemCode][field],
        'isRequiredRemark': isRequiredRemark
      }
    }));

  }


  const handleGetUrbanConsumerPriceFormData = async (e, buttonType) => {
    const customItemCodes = [];
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
    //HQ Reject: Block select is mandatory
    if (
      type === "rural" &&
      buttonType === "REJECT" &&
      userInfoObject.userLevel === "HEAD QUARTER" &&
      (!blockCode || blockCode === "")
    ) {
      toast.error(messages.BLOCK_MSG, messages.COLOR_RED);
      return false;
    }
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel) //button click status flag
    let check = 0;
    let statusFlag = '';
    for (let itemId in itemData) {
      let currentPrice = itemData[itemId].currentPrice;
      let remark = itemData[itemId].remark;
      let isRequiredRemark = itemData[itemId].isRequiredRemark;
      let isRejectStatus = itemData[itemId].isRejectStatus

      statusFlag = (itemData[itemId].statusFlag === '') ?
        clickButtonStatusFlag
        :
        itemData[itemId].statusFlag

      if (buttonType === "REJECT" && isRejectStatus) {
        check++;
        if (isRequiredRemark) {
          toast.error(messages.REMARK_MSG, messages.COLOR_RED);
          return false;
        }
        statusFlag = clickButtonStatusFlag
      }

      if (buttonType === "ACCEPT" || buttonType === "SAVE") {
        statusFlag = clickButtonStatusFlag
      }

      if (buttonType === "SUBMIT") {
        statusFlag = clickButtonStatusFlag;
      }

      if (currentPrice === '' || currentPrice === null || currentPrice == undefined) {
        currentPrice = "0.00";

      }


      if (isRequiredRemark && remark === 'NQ') {
        toast.error(messages.REMARK_MSG, messages.COLOR_RED);
        return false;
      }

      if (remark === '' || remark == null) {
        remark = 'NQ';
      }


      const customObject = {
        itemCode: itemId,
        currentPrice: currentPrice,
        remark: remark,
        status: isRejectStatus,
        statusFlag: statusFlag

      };

      customItemCodes.push(customObject);
    };


    if (buttonType === "REJECT" && check === 0) {
      toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
      return false;
    }


    let postData = {
      itemCodes: customItemCodes,
      payload: {
        block_code: blockCode,
        district_code: districtCode,
        month_name: monthName,
        year_name: yearName,
        buttonType: buttonType,
        statusButtonFlag: clickButtonStatusFlag
      }
    }

    showLoading(true)
    try {

      const response = await axios.post(`${API_URL}api/consumerRetail/${url}`, postData, config);
      if (response.data.status) {
        toast.success(response.data.message, messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
      resetForm();
    }


  }


  const resetForm = () => {

    const initialData = {};
    urbanAndRuralCommonItemPrice.forEach(group => {
      group.subGroups.forEach(subGroup => {
        subGroup.itemCodes.forEach(item => {
          initialData[item.itemCode] = {
            currentPrice: '',
            remark: '',
            style: '',
            isRequiredRemark: false,
            isRejectStatus: false

          };
        });
      });
    });
    setItemData(initialData);
    resetMothAndYearField()
  }

  const checkBoxcheckedLength = () => {

    const filteredData = Object.fromEntries(
      Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
    );
    return Object.keys(filteredData).length

  }


// if hq then save and reject desable
 const HqSubmitReject=()=>{
  let isDisable=false;
  if(userInfoObject.userLevel === "HEAD QUARTER" && payload.statusFlagSet === ''  ){
    isDisable=true
  }
  return isDisable;
 }

  return (
  
    <>
      {/* <ToastContainer /> */}
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered consumer_retail_table">

            {urbanAndRuralCommonItemPrice && urbanAndRuralCommonItemPrice.map((mjgroup, i) => {

              return <React.Fragment>
                {renderHeader(i)}
                <tbody>
                  {majorGroupRow(i, mjgroup)}

                  {mjgroup.subGroups.map((sbgroup, j) => {
                    subGroupsSerialNumber++;

                    return <React.Fragment key={`subGroupFragment-${i}-${j}`}>

                      {subGroupRow(subGroupsSerialNumber, i, j, sbgroup)}

                      {sbgroup.itemCodes.map((item, k) => {
                        ItemSerialNumber++;

                        if (checkBoxcheckedLength() > 0) {
                          isDisable = false
                        } else if (payload.statusFlagSet === "6") {
                          if (finalIsAcceptBtnDisable && checkBoxcheckedLength() !== 0) {
                            isDisable = true
                          }

                        } else if (finalIsAcceptBtnDisable) {

                          isDisable = false
                        }

                        if ((userInfoObject.userLevel === 'DISTRICT LEVEL' || userInfoObject.userLevel === 'DIVISION LEVEL')) {
                          districtAndDivision = true;
                        }
                        const isItemCodeInArray = commonDisabledItemCode.includes(item.itemCode);



                        return <tr key={`row-${k}-${ItemSerialNumber}`}>
                          <td><input type="text" id={`itemSlno${ItemSerialNumber}`} className="form-control" maxLength="3" value={ItemSerialNumber} disabled /></td>
                          <td><input type="text" id={`itemCode${ItemSerialNumber}`} className="form-control" maxLength="3" value={item.itemCode} disabled /></td>
                          <td><input type="text" id={`itemName${ItemSerialNumber}`} className="form-control" maxLength="50" value={item.itemName}
                            disabled />
                          </td>
                          <td><input type="text" id={`varietyName${ItemSerialNumber}`} className="form-control" maxLength="50" value={item.variety} disabled />
                          </td>
                          <td>
                            {/* ***********unitData********* */}
                            <select
                              value={item.itemUnitCode}
                              id={`itemUnit${ItemSerialNumber}`}
                              name={`itemUnit${ItemSerialNumber}`}
                              className="form-select"
                              disabled
                            >
                              <option key={item.itemUnitCode}>{item.itemUnitName}</option>
                            </select>

                          </td>
                          <td>
                            <input type="text"
                              disabled={isItemCodeInArray || (!onlyDistrictSelected && isReadOnlyMode) ? 'disabled' : ''}
                              style={itemData[item.itemCode]?.style || {}}
                              key={ItemSerialNumber}
                              className="form-control"
                              maxLength="12"
                              name={`currentPrice_${[item.itemCode]}`}
                              id={`currentPrice${item.itemCode}`}
                              value={itemData[item.itemCode]?.currentPrice}
                              onChange={e => handleOnChange(item.itemCode, 'currentPrice', e.target.value)}
                              onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, item.variationLimit)}
                            />
                          </td>
                          <td>
                          {
                          userInfoObject.userLevel === "HEAD QUARTER" ?
                          item.remark !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.remark) &&
                          otherRemark.includes(itemData[item.itemCode]?.remark) &&
                            <label className="text-danger" style={{ fontSize: '12px' }}>*{item.remark}</label>
                          
                          :
                          item.remark !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.remark) &&
                          headQuarterRemark.includes(itemData[item.itemCode]?.remark) &&
                            <label className="text-danger" style={{ fontSize: '12px' }}>*{item.remark}</label>
							
					                 }

                            <select
                              disabled={isItemCodeInArray || (!onlyDistrictSelected && isReadOnlyMode) ? 'disabled' : ''}
                              name={`remark_${ItemSerialNumber}`}
                              id={`remark${ItemSerialNumber}`}
                              className="form-select"
                              value={itemData[item.itemCode]?.remark || ''}
                              onChange={e => handleOnChange(item.itemCode, 'remark', e.target.value)}
                            >
                              <option value="">[---Select---]</option>
                              	
                              { userInfoObject.userLevel === "HEAD QUARTER" ?
                          
                                  headQuarterRemark.map((remarkItem,i)=>{
                                    return (
                                    <option value={remarkItem} key={i}>{remarkItem}</option>
                  
                                  )})
                                 :
                        
                                  otherRemark.map((remarkItem,i)=>{
                                    return (
                                    <option value={remarkItem} key={i}>{remarkItem}</option>
                  
                                  )})
                               }

                            </select>

                            {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                              (
                                <div style={{ color: 'red', marginTop: '10px' }} kei={ItemSerialNumber}>
                                  Please Select the Remark
                                </div>
                              )
                              :
                              ''
                            }
                          </td>
                          <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
                            <input
                              disabled={districtAndDivision || isItemCodeInArray || (!onlyDistrictSelected && isReadOnlyMode) ? 'disabled' : ''}
                              type="checkbox"
                              name={`status${ItemSerialNumber}`}
                              id={`status${ItemSerialNumber}`}
                              onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.value)}
                              checked={itemData[item.itemCode]?.isRejectStatus || false}

                            />
                          </td>
                        </tr>


                      })}

                    </React.Fragment>


                  })}


                </tbody>
              </React.Fragment>

            })

            }

          </table>
        </div>

        <div className="row">
          <div className="col-12 text-center pt-3">

            {
              <button
                onClick={(e) => handleGetUrbanConsumerPriceFormData(e, 'SAVE')}
                type="button"
                className={`btn btn_orange mx-1 ${(finalIsSaveBtnDisable) ? 'disabled' : ''}`}
                id="saved"
              >Save
              </button>
            }

            {
              (userInfoObject.userLevel === 'DISTRICT LEVEL' ||
                userInfoObject.userLevel === 'DIVISION LEVEL' || userInfoObject.userLevel === 'HEAD QUARTER') &&

              // <button
              //   onClick={(e) => handleGetUrbanConsumerPriceFormData(e, 'SUBMIT')}
              //   type="submit"
              //   className={`btn btn_orange mx-1 ${isSubmitBtnDisable || checkBoxcheckedLength() > 0 ? 'disabled' : ''}`}
              //   id="submited"
              // >Submit
              // </button>

              <button
              onClick={(e) => handleGetUrbanConsumerPriceFormData(e, 'SUBMIT')}
              type="submit"
              className={`btn btn_orange mx-1 ${(finalIsSubmitBtnDisable) ? 'disabled' : ''}`}
              id="submited"
              >Submit
              </button>
            }


            {(userInfoObject.userLevel === 'HEAD QUARTER') &&
              <>
                <button
                  onClick={(e) => handleGetUrbanConsumerPriceFormData(e, 'ACCEPT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${finalIsAcceptBtnDisable ? 'disabled' : ''
                    }`}
                >Accept
                </button>

                <button
                  onClick={(e) => handleGetUrbanConsumerPriceFormData(e, 'REJECT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${(finalIsRejectBtnDisable) ? 'disabled' : ''}`}
                >Reject
                </button>
              </>
            }

            <button
              type="reset"
              className="btn btn_orange mx-1"
              onClick={resetForm}
            >Reset
            </button>

            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={(e) => (navigate("/dashboard"))}
            >Cancel
            </button>

          </div>
        </div>

      </div>

    </>
  )
}
